import { NotificationManager } from 'react-notifications';
import Cookies from 'universal-cookie';
import * as CONST from '../ActionTypes';
import * as util from './util';

// @ts-ignore
// import { NotificationManager } from 'react-notifications';

const cookies = new Cookies();

/**
 *  カートー覧取得
 */
// eslint-disable-next-line import/prefer-default-export
export const getCartList = (accessToken, limit, offset) => (dispatch) => fetch(
  // eslint-disable-next-line no-undef
  `${process.env.REACT_APP_ENDPOINT}/api/v1/carts/${process.env.REACT_APP_COMPANY_ID}?limit=${limit}&offset=${offset}`,
  {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    mode: 'cors',
  },
)
  .then((response) => response.json())
  .then((payload) => {
    dispatch(util.actionType(CONST.GET_CART_LIST_SUCCESS, payload));
  })
  .catch((error) => {
    dispatch(util.actionType(CONST.GET_CART_LIST_FAILURE, error));
  });
/**
 *  カートー覧取得
 */
// eslint-disable-next-line import/prefer-default-export
export const getBuyHistory = (accessToken, limit, offset) => (dispatch) => fetch(
  // eslint-disable-next-line no-undef
  `${process.env.REACT_APP_ENDPOINT}/api/v1/subscriptions/with_customer?limit=-1&offset=${offset}`,
  {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    mode: 'cors',
  },
)
  .then((response) => response.json())
  .then((payload) => {
    // タワー型噴霧器TERRA FORESTAミスト
    let isBuyProduct = false;
    payload.forEach((item) => {
      if (item.products[0].name === 'タワー型噴霧器　TERRA FORESTAミスト') {
        isBuyProduct = true;
      }
    });
    dispatch(util.actionType(CONST.GET_BUY_HISTORY_SUCCESS, isBuyProduct));
  })
  .catch((error) => {
    dispatch(util.actionType(CONST.GET_BUY_HISTORY_FAILURE, error));
  });
/**
 *  カート作成
 */
export const createCart = (accessToken, prds) => () => {
  const params = {
    products: prds,
    company_id: Number(process.env.REACT_APP_COMPANY_ID),
    shipping: Number(0),
  };
  return fetch(
    // eslint-disable-next-line no-undef
    `${process.env.REACT_APP_ENDPOINT}/api/v1/carts/`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(params),
      mode: 'cors',
    },
  ).then((response) => response.json());
};

/**
 *  ローカルカートー覧取得
 */
export const getCartListLocal = () => (dispatch) => {
  const c = localStorage.getItem('cart');
  if (c) {
    const cart = JSON.parse(c);
    let isChanged = false;
    cart.forEach((crt, i) => {
      if (crt.product_category) {
        isChanged = true;
        cart[i].product_categories = [crt.product_category];
      } else if (!crt.product_categories) {
        isChanged = true;
        cart.splice(i, 1);
      }
      return crt;
    });
    if (isChanged) {
      localStorage.setItem('cart', JSON.stringify(cart));
    }
    let total = 0;
    // eslint-disable-next-line array-callback-return
    cart.map((crt) => {
      total += Number(crt.count) * Number(crt.price);
    });
    dispatch(util.actionType(CONST.SET_TOTAL_CART, total));
    dispatch(util.actionType(CONST.GET_CART_LIST_LOCAL_SUCCESS, cart));
  }
};

/**
 * カート更新
 */
export const updateCart = (carts, accessToken) => () => {
  const param = {
    company_id: Number(process.env.REACT_APP_COMPANY_ID),
    products: carts,
  };
  return fetch(
    // eslint-disable-next-line no-undef
    `${process.env.REACT_APP_ENDPOINT}/api/v1/carts/`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(param),
      mode: 'cors',
    },
  );
};

/**
 * カート追加
 */
export const addToCart = (product, count, accessToken, isLoggedIn, page, history) => (dispatch) => {
  dispatch(util.actionType(CONST.TOGGLE_CHANGE_CART, true));
  const cartStr = localStorage.getItem('cart');
  let newCart = [];
  if (cartStr) {
    const cartJson = JSON.parse(cartStr);
    let isChanged = false;
    cartJson.forEach((crt, i) => {
      if (crt.product_category) {
        isChanged = true;
        cartJson[i].product_categories = [crt.product_category];
      } else if (!crt.product_categories) {
        isChanged = true;
        cartJson.splice(i, 1);
      }
      return crt;
    });
    if (isChanged) {
      localStorage.setItem('cart', JSON.stringify(cartJson));
    }
    const selectedPrdIndex = cartJson.findIndex(
      (prd) => prd.product_id === product.id,
    );
    if (selectedPrdIndex >= 0) {
      cartJson[selectedPrdIndex].count += Number(count);
    } else {
      if (cartJson.length > 0) {
        if (product.product_categories[0]?.category_name === 'LP'
        || cartJson[0].product_categories[0]?.category_name === 'LP') {
          NotificationManager.error('専用ページ経由でご購入の定期商品は他の商品と同時に購入できません。');
          return;
        }
        // 定期便の商品かどうかチェック
        let isSubscription = false;
        if (product.product_categories[0]?.category_name === '定期便'
        || product.id.toLocaleString() === process.env.REACT_APP_PRODUCT_ID_LP_1000.split(',')[0].toLocaleString()
        || product.id.toLocaleString() === process.env.REACT_APP_PRODUCT_ID_LP_1000.split(',')[1].toLocaleString()) {
          isSubscription = true;
        }
        if (isSubscription && cartJson[0].product_categories[0]?.category_name === '単品') {
          NotificationManager.error('単品商品と定期購入商品は同時に購入できません。');
          return;
        }
        if (!isSubscription && cartJson[0].product_categories[0]?.category_name !== '単品') {
          NotificationManager.error('単品商品と定期購入商品は同時に購入できません。');
          return;
        }
      }
      cartJson.push({
        product_id: product.id,
        name: product.name,
        image: product.main_image,
        price: product.price,
        count: Number(count),
        product_categories: product.product_categories,
      });
    }
    newCart = cartJson;
  } else {
    newCart = [
      {
        product_id: product.id,
        name: product.name,
        image: product.main_image,
        price: product.price,
        count: Number(count),
        product_categories: product.product_categories,
      },
    ];
  }
  localStorage.setItem('cart', JSON.stringify(newCart));
  if (product.id.toLocaleString() === process.env.REACT_APP_PRODUCT_ID_SPECIAL_DISCOUNT.split(',')[0].toLocaleString()
  || product.id.toLocaleString() === process.env.REACT_APP_PRODUCT_ID_SPECIAL_DISCOUNT.split(',')[1].toLocaleString()) {
    cookies.set('rule_group_id', Number(process.env.REACT_APP_RULE_GROUP_ID_SPECIAL_DISCOUNT), { path: '/' });
  }
  if (isLoggedIn) {
    dispatch(updateCart(newCart, accessToken));
  }
  history.push(`/${page}`);
  // NotificationManager.success(`${product.name}を入れた`);
};

/** GET_CART_LIST_LOCAL_SUCCESS
 * カートマージ
 */
export const mergeCart = (products, accessToken) => (dispatch) => {
  dispatch(util.actionType(CONST.TOGGLE_CHANGE_CART, true));
  const cartStr = localStorage.getItem('cart');
  let newCart = [];
  if (cartStr) {
    const cartJson = JSON.parse(cartStr);
    let isChanged = false;
    cartJson.forEach((crt, i) => {
      if (crt.product_category) {
        isChanged = true;
        cartJson[i].product_categories = [crt.product_category];
      } else if (!crt.product_categories) {
        isChanged = true;
        cartJson.splice(i, 1);
      }
      return crt;
    });
    if (isChanged) {
      localStorage.setItem('cart', JSON.stringify(cartJson));
    }
    // eslint-disable-next-line array-callback-return
    products.map((prd) => {
      const selectedPrdIndex = cartJson.findIndex(
        (p) => prd.product_id === p.product_id,
      );
      if (selectedPrdIndex < 0) {
        cartJson.push({
          product_id: prd.product_id,
          name: prd.name,
          image: prd.image,
          price: prd.price,
          count: Number(prd.count),
          product_categories: prd.product_categories,
        });
      }
    });
    newCart = cartJson;
  } else {
    // const prds = [];
    // eslint-disable-next-line array-callback-return
    products?.map((prd) => {
      newCart.push({
        product_id: prd.product_id,
        name: prd.name,
        image: prd.image,
        price: prd.price,
        count: Number(prd.count),
        product_categories: prd.product_categories,
      });
    });
    // if (prds.length >= 1) {
    //   newCart.push({
    //     prds,
    //   });
    // }
  }
  localStorage.setItem('cart', JSON.stringify(newCart));
  dispatch(updateCart(newCart, accessToken));
};

/**
 * カート削減
 */
export const deleteCartItem = (productID, accessToken, isLoggedIn) => (dispatch) => {
  dispatch(util.actionType(CONST.TOGGLE_CHANGE_CART, true));
  const cartStr = localStorage.getItem('cart');
  let newCart = [];
  if (cartStr) {
    const cartJson = JSON.parse(cartStr);
    let isChanged = false;
    cartJson.forEach((crt, i) => {
      if (crt.product_category) {
        isChanged = true;
        cartJson[i].product_categories = [crt.product_category];
      } else if (!crt.product_categories) {
        isChanged = true;
        cartJson.splice(i, 1);
      }
      return crt;
    });
    if (isChanged) {
      localStorage.setItem('cart', JSON.stringify(cartJson));
    }
    const selectedPrdIndex = cartJson.findIndex(
      (item) => item.product_id === productID,
    );
    if (selectedPrdIndex >= 0) {
      cartJson.splice(selectedPrdIndex, 1);
    }
    newCart = cartJson;
  }
  localStorage.setItem('cart', JSON.stringify(newCart));
  if (productID.toLocaleString() === process.env.REACT_APP_PRODUCT_ID_SPECIAL_DISCOUNT.split(',')[0].toLocaleString()
  || productID.toLocaleString() === process.env.REACT_APP_PRODUCT_ID_SPECIAL_DISCOUNT.split(',')[1].toLocaleString()
  ) {
    cookies.remove('rule_group_id', { path: '/' });
  }
  if (isLoggedIn) {
    dispatch(util.actionType(CONST.DELETE_CART_ITEM_SUCCESS, newCart));
    dispatch(updateCart(newCart, accessToken));
  }
};

/**
 * カート削減
 */
export const deleteCart = (accessToken, isLoggedIn) => (dispatch) => {
  dispatch(util.actionType(CONST.DELETE_CART, null));
  dispatch(util.actionType(CONST.TOGGLE_CHANGE_CART, true));
  localStorage.removeItem('cart');
  cookies.remove('rule_group_id', { path: '/' });
  if (isLoggedIn) {
    dispatch(updateCart([], accessToken));
  }
};

/**
 * カート更新フラグを更新
 */
export const disableFlag = () => (dispatch) => {
  dispatch(util.actionType(CONST.TOGGLE_CHANGE_CART, false));
};

/**
 * updateQuantityCartItem
 */
// eslint-disable-next-line max-len
export const updateQuantityCartItem = (productId, quantity, accessToken, isLoggedIn) => (dispatch) => {
  dispatch(util.actionType(CONST.TOGGLE_CHANGE_CART, true));
  const cartStr = localStorage.getItem('cart');
  let newCart = [];
  if (cartStr) {
    const cartJson = JSON.parse(cartStr);
    let isChanged = false;
    cartJson.forEach((crt, i) => {
      if (crt.product_category) {
        isChanged = true;
        cartJson[i].product_categories = [crt.product_category];
      } else if (!crt.product_categories) {
        isChanged = true;
        cartJson.splice(i, 1);
      }
      return crt;
    });
    if (isChanged) {
      localStorage.setItem('cart', JSON.stringify(cartJson));
    }
    const selectedPrdIndex = cartJson.findIndex(
      (item) => item.product_id === productId,
    );
    if (selectedPrdIndex >= 0) {
      cartJson[selectedPrdIndex].count = Number(quantity);
    }
    newCart = cartJson;
  }
  localStorage.setItem('cart', JSON.stringify(newCart));
  if (isLoggedIn) {
    dispatch(updateCart(newCart, accessToken));
  }
};
